"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Figure = ({ alt, backgroundImage = 'https://st.depositphotos.com/1780879/3816/i/600/depositphotos_38166573-stock-photo-trees-with-sunbeams.jpg', width = 454, height = 454, className, }) => {
    return ((0, jsx_runtime_1.jsx)("img", { "data-testid": "figure-component", src: backgroundImage, alt: alt, height: height, width: width, className: className }, void 0));
};
exports.default = Figure;
